<template>
  <span class="bot-action" @click="callback($event)">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: ['action'],
  methods: {
    callback: function(e) {
      this.$emit('click', e);
    }
  }
}
</script>

<style lang="scss">
  .bot-action {
    display: inline-block;
    width: auto;
    margin: 8px 8px;
    padding: 8px 12px;
    color: rgba(255,255,255,0.75);
    border: 1px solid #777777;
    font-size: 12px;
    text-align: center;
    cursor: pointer;    
    border-radius: 2px;
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    text-transform: capitalize;

    &.icon {
      padding: 0;
      height: 32px;
      width: 32px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-size: 1.75em;
    }
    &.no-margins {
      margin: 0;
    }

    &:hover {
      color: rgba(255,255,255, 1);
    }

    &.blue {
      background-color: #086FDA;
      border: 1px solid #7BBAFF;

      &:hover {
        border-color: rgb(151, 200, 253);
      }
    }

    &.gray {
      background-color: #555555; 

      border: 1px solid rgba($color: #ffffff, $alpha: 0.2);

      &:hover {
        border-color: rgba($color: #ffffff, $alpha: 0.75);
      }
    }

    &.red {
      border-color: #762D2D;
      background-color: #543737;
      color: #FF2C2C;
      &:hover {
        border-color: #FF0707;
      }
    }

    &.shadow {
      box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
      &:hover {
        box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
      }
      &:active {
        box-shadow: 0 0px 0px rgba(0,0,0,0.16), 0 0px 0px rgba(0,0,0,0.23);
      }
    }

    &.disabled {
      cursor: default;
      opacity: 0.25;
      &:hover {
        opacity: 0.25;
      }
    }

    &.wide {
      width: 100%;
      margin: 8px 0;
    }
    
  }
  
</style>